$(document).ready(function(){
    var targetPosition = 2;

    var onScroll = function () {
        scrollPosition = $(this).scrollTop();
        //console.log(scrollPosition);
        if (scrollPosition >= targetPosition) {
            //console.log("function hit");
            $('.mobile_header_nav').addClass('mobile_visible');
        }
        else{
            $('.mobile_header_nav').removeClass('mobile_visible');
        }
    }

    $(window).on('scroll', onScroll);
});